import { currencyFormat } from 'common/helpers/numberHelper';

const OrderValueMessage = (props) => {
  const { clubPackage, settings } = props;
  if (clubPackage.itemChoice !== 'User Can Choose') {
    return null;
  }
  if (!clubPackage.minOrderValueOfShipment) {
    return null;
  }
  return (
    <>
      {' '}
      Your order must be a minimum of{' '}
      <strong>
        {currencyFormat(clubPackage.minOrderValueOfShipment, settings)}
      </strong>
      .
    </>
  );
};

export default OrderValueMessage;
